// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3YErm","fileBtn":"File_fileBtn__1uNQm","closeBtn":"File_closeBtn__2AspE","fileSelected":"File_fileSelected__2RAmT","disabled":"File_disabled__2j0iU"};